<template>
  <div>
    <div class="main-box">
      <h2>【重要提示】</h2>
      <div class="prompt_lang">
        <p>
          1、设置试卷独立密码后，可以对试卷进行加密操作，已加密试卷需要解密后才可进行操作；
        </p>
        <p>
          2、在“试题管理”中开启试题保护后，试题管理内的自主试题需验证独立密码后才可使用；
        </p>
        <p>
          3、由于加密的不可逆，若遗忘独立密码，所加密的试卷/试题将不能恢复(只能删除)，请务必牢记独立密码。
        </p>
      </div>
      <div class="oper_prompt">您已设置过独立密码，请选择操作。</div>
      <!-- 验证独立密码 -->
      <div class="validation">
        <el-form
          :model="UserForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div class="password_box">
            <div class="password_input">
              <el-form-item label="验证旧独立密码：" prop="password">
                <el-input
                  placeholder="请输入旧独立密码"
                  v-model.trim="UserForm.password"
                  :type="flag ? 'password' : 'text'"
                  autocomplete="off"
                >
                  <template>
                    <i
                      slot="suffix"
                      class="iconfont"
                      :class="flag ? 'icon-yincangmima' : 'icon-eyes'"
                      @click="flag = !flag"
                    ></i>
                  </template>
                </el-input>
                <span class="isError" v-if="isError">密码错误</span>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>

      <p class="red">
        温馨提示：为保护数据，撤销独立密码后会解密所有已加密试卷并关闭试题保护，是否继续？
      </p>
    </div>
    <!-- 按钮操作 -->
    <div class="operation">
      <el-button size="mini" @click="toHome">返回</el-button>
      <el-button size="mini" @click="cancelCrypto">验证</el-button>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import { validationUndo } from "@/utils/validata";
import { cancelCryptoPwd } from "@/api/examination.js";
import loginvuex from "@/store/index";
import md5 from "js-md5";
export default {
  data() {
    return {
      stateArr: [], //存储开始时间和结束时间。
      flag: true, // input查看隐藏密码的矢量图
      state: "",
      UserForm: {
        password: "",
      },
      isError: false, // 密码错误提示框
      rules: {
        password: [{ validator: validationUndo, trigger: "blur" }],
      },
    };
  },
  methods: {
    // 取消返回首页
    toHome() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:ModifyThe:tab2:back",
          parent_code: "PersonalCenter:ModifyThe",
        },
        "statetime"
      );
      this.$router.push("/papers");
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields(); // 重置
    },
    submitForm(ruleForm) {
      // 确定校验
      this.$refs[ruleForm].validate((valid) => {
        console.log(valid);
      });
    },
    async cancelCrypto() {
      this.Buriedpoint(
        {
          code: "PersonalCenter:ModifyThe:tab2:validate",
          parent_code: "PersonalCenter:ModifyThe",
        },
        "statetime"
      );
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        cryptoPwd: md5(this.UserForm.password),
      };
      const Data = await cancelCryptoPwd(params);

      if (Data.data.Status === 200) {
        this.$message({
          message: "恭喜你，撤销密码成功",
          type: "success",
        });
        this.UserForm = "";
        this.$router.go(0);
      } else if (Data.data.Status === 202) {
        this.$message.error(Data.data.Data);
      } else {
        this.$message.error(Data.data.Data);
        this.isError = true;
      }
    },
  },
  created() {
    this.stateArr = [];
    localStorage.removeItem("isreload");
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  min-width: 1600px;
  margin-top: 50px;
  h2 {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 21px;
    color: #333333;
    opacity: 1;
  }
  .prompt_lang {
    margin-top: 30px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 36px;
    // color: #ff0000;
    opacity: 1;
    p:nth-last-child(1) {
      color: #ff0000;
    }
  }
  .oper_prompt {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 21px;
    color: #333333;
    opacity: 1;
    margin: 30px 0 30px 0;
  }
  .validation {
    display: flex;
    align-content: center;
    margin-bottom: 20px;
    p {
      width: 124px;
      height: 56px;
      line-height: 56px !important;
      margin-right: 30px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 36px;
      color: #333333;
      opacity: 1;
    }
    ::v-deep .el-input__inner {
      width: 450px;
      height: 56px;
    }
  }
}
.red {
  color: #ff0000;
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  color: #ff0000;
  opacity: 1;
  margin-bottom: 370px;
}
.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 50px 0 186px 0;

  .el-button {
    width: 162px;
    height: 50px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #ffffff;
    opacity: 1;
  }
  .el-button:nth-child(1) {
    background: #eeeeee;
    color: #999999;
  }

  .el-button:nth-child(2) {
    margin-left: 90px;
    background: #0fc758;
    color: #ffffff;
  }
}
.isError {
  color: #ff0000 !important;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 36px;
  opacity: 1;
}
::v-deep .el-input__suffix {
  right: 16px;
  top: 8px;
  i {
    font-size: 22px;
    display: inline-block;
  }
  i:nth-of-type(1) {
    margin-left: 12px;
  }
  i:nth-child(2) {
    display: none;
  }
}
::v-deep .el-form-item__content {
  margin-left: 128px !important;
}
::v-deep .el-form-item__label {
  width: 128px !important;
  text-align: left;
  line-height: 54px;
}
.password_box {
  padding: 40px 30px 60px 0px;
  .password_input {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    p {
      width: 120px;
      height: 24px;
    }

    > div {
      p {
        width: 100% !important;
        margin-left: 102px;
        font-size: 13px;
      }
    }
    ::v-deep .el-input--suffix .el-input__inner {
      width: 450px;
      height: 56px !important;
    }
  }
}
</style>